import { SecretKeyConfig, graphQLConfig,s3Config, APIGateWayConfig, QuickSightDashboardConfig, GlueJobConfig, StepFunctionConfig} from 'src/context/AppContextModels';

export const APP_TITLE = 'Accounting Central';

export const eLDAPGroup = {
  ADMIN_LDAP: 'ateam-bi',
  DEV_LDAP: 'ateam-bi'
};

export const LDAP_ADMINS: string[] = ['ateam-bi'];

export const SECRET_KEY_ARN_CONFIG: SecretKeyConfig[] = [
  {
    environment: 'alpha',
    secretARN: 'arn:aws:secretsmanager:us-west-2:657018391063:secret:accounting-bi-central-appSync-APIKey-alpha-H8daPY'
  },
  {
    environment: 'dev',
    secretARN: 'arn:aws:secretsmanager:us-west-2:330801203043:secret:accounting-bi-central-appSync-APIKey-beta-KHdswc'
  },
  {
    environment: 'beta',
    secretARN: 'arn:aws:secretsmanager:us-west-2:330801203043:secret:accounting-bi-central-appSync-APIKey-beta-KHdswc'
  },
  {
    environment: 'prod',
    secretARN: 'arn:aws:secretsmanager:us-west-2:359182851103:secret:accounting-bi-central-appSync-APIKey-prod-4oNu4S'
  }
];

export const GRAPHQL_CONFIG: graphQLConfig[] =  [
  {
    environment: 'alpha',
    secretName : 'accounting-bi-central-appSync-APIKey-alpha',
    grapQLEndPoint : 'https://s2g3cop62zgcvlrf26ascfla3q.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'dev',
    secretName : 'accounting-bi-central-appSync-APIKey-beta',
    grapQLEndPoint : 'https://efkypdtrnne37djo7ryeqlbwqm.appsync-api.us-east-1.amazonaws.com/graphql'
  },

  {
    environment: 'beta',
    secretName : 'accounting-bi-central-appSync-APIKey-beta',
    grapQLEndPoint : 'https://efkypdtrnne37djo7ryeqlbwqm.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'prod',
    secretName : 'accounting-bi-central-appSync-APIKey-prod',
    grapQLEndPoint : 'https://mgu5jvaqbjh5xntepue27znrhm.appsync-api.us-east-1.amazonaws.com/graphql',
  }
];

export const MJE_GRAPHQL_CONFIG: graphQLConfig[] =  [
  {
    environment: 'alpha',
    secretName : 'accounting-bi-central-appSync-APIKey-alpha',
    grapQLEndPoint : 'https://s2g3cop62zgcvlrf26ascfla3q.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'dev',
    secretName : 'accounting-bi-central-appSync-APIKey-beta',
    grapQLEndPoint : 'https://efkypdtrnne37djo7ryeqlbwqm.appsync-api.us-east-1.amazonaws.com/graphql'
  },

  {
    environment: 'beta',
    secretName : 'accounting-bi-central-appSync-APIKey-beta',
    grapQLEndPoint : 'https://efkypdtrnne37djo7ryeqlbwqm.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'prod',
    secretName : 'accounting-bi-central-appSync-APIKey-prod',
    grapQLEndPoint : 'https://mgu5jvaqbjh5xntepue27znrhm.appsync-api.us-east-1.amazonaws.com/graphql',
  }
];

export const FLEXICO_GRAPHQL_CONFIG: graphQLConfig[] =  [
  {
    environment: 'alpha',
    secretName : '',
    grapQLEndPoint : 'https://l7fttjuoobagfla7vjkiurv5v4.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'dev',
    secretName : '',
    grapQLEndPoint : 'https://cmw7t4kaavexzad62kmwmecvlu.appsync-api.us-east-1.amazonaws.com/graphql'
  },

  {
    environment: 'beta',
    secretName : '',
    grapQLEndPoint : 'https://cmw7t4kaavexzad62kmwmecvlu.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'prod',
    secretName : '',
    grapQLEndPoint : 'https://2m7fqxuva5fwxly67eyywwhww4.appsync-api.us-east-1.amazonaws.com/graphql',
  }
];

export const APPSYNC_PLUS_GRAPHQL_CONFIG: graphQLConfig[] =  [
  {
    environment: 'alpha',
    secretName : '',
    grapQLEndPoint : 'https://icfizqhg7jgbfexh6ap3xtzn7y.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'dev',
    secretName : '',
    grapQLEndPoint : 'https://7sapniobunfotk7xndfciqgdqe.appsync-api.us-east-1.amazonaws.com/graphql'
  },

  {
    environment: 'beta',
    secretName : '',
    grapQLEndPoint : 'https://7sapniobunfotk7xndfciqgdqe.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'prod',
    secretName : '',
    grapQLEndPoint : 'https://ojlqwlgjufc4nhzbgamqfu7fvu.appsync-api.us-east-1.amazonaws.com/graphql',
  }
];

// AppSync endpoint for Reconcentral (presigned S3 URL generation).
export const RECONCENTRAL_GRAPHQL_CONFIG: graphQLConfig[] = [
  {
    environment: 'dev',
    secretName: '',
    grapQLEndPoint: 'https://cqblzurltrcstbnmfj4eid6dfe.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'beta',
    secretName: '',
    grapQLEndPoint: 'https://cqblzurltrcstbnmfj4eid6dfe.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'prod',
    secretName: '',
    grapQLEndPoint: 'https://cqblzurltrcstbnmfj4eid6dfe.appsync-api.us-east-1.amazonaws.com/graphql'
  }
];

// AppSync endpoint for the AutoMate agent (AgentChatAPIs / AISearchAppSync).
// Lives in its own dedicated CDK stack with Cognito user-pool auth.
//
// TODO: Replace with per-stage AppSync endpoints once provisioned. All envs
// currently share a single endpoint, which breaks environment isolation:
// beta testing can affect production capacity, and a bug in the agent
// backend would impact all stages simultaneously.
export const AGENT_GRAPHQL_CONFIG: graphQLConfig[] = [
  {
    environment: 'alpha',
    secretName: '',
    grapQLEndPoint: 'https://s2g3cop62zgcvlrf26ascfla3q.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'dev',
    secretName: '',
    grapQLEndPoint: 'https://aap6bxjqrjdoln2pxlgmcum2wu.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'beta',
    secretName: '',
    grapQLEndPoint: 'https://aap6bxjqrjdoln2pxlgmcum2wu.appsync-api.us-east-1.amazonaws.com/graphql'
  },
  {
    environment: 'prod',
    secretName: '',
    grapQLEndPoint: 'https://on3ifoig6vg2hiukpsb2747p2m.appsync-api.us-east-1.amazonaws.com/graphql'
  }
];

export const S3_CONFIG: s3Config[] =  [
  {
    environment: 'alpha',
    bucket : 'abc-generic-bucket-alpha',
    region : 'us-east-1'
  },
  {
    environment: 'dev',
    bucket : 'ui4bi-bucket84824-dev',
    region : 'us-east-1'
  },

  {
    environment: 'beta',
    bucket : 'ui4bi-bucket84824-dev',
    region : 'us-east-1'
  },
  {
    environment: 'prod',
    bucket : 'ui4bi-prod-bucket164517-dev',
    region : 'us-east-1',
  }
];

export const MJE_S3_CONFIG: s3Config[] =  [
  {
    environment: 'alpha',
    bucket : 'abc-generic-bucket-alpha',
    region : 'us-east-1'
  },
  {
    environment: 'dev',
    bucket : 'ui4bi-bucket84824-dev',
    region : 'us-east-1'
  },

  {
    environment: 'beta',
    bucket : 'ui4bi-bucket84824-dev',
    region : 'us-east-1'
  },
  {
    environment: 'prod',
    bucket : 'ui4bi-bucket-prod140700-dev',
    region : 'us-east-1',
  }
];

export const FRISCO_S3_CONFIG: s3Config[] =  [
  {
    environment: 'alpha',
    bucket : 'alpha-frisco',
    region : 'us-east-1'
  },
  {
    environment: 'dev',
    bucket : 'beta-frisco',
    region : 'us-east-1'
  },

  {
    environment: 'beta',
    bucket : 'beta-frisco',
    region : 'us-east-1'
  },
  {
    environment: 'prod',
    bucket : 'prod-frisco',
    region : 'us-east-1',
  }
];

export const LOGICO_S3_CONFIG: s3Config[] =  [
  {
    environment: 'alpha',
    bucket : 'alpha-logico',
    region : 'us-east-1'
  },
  {
    environment: 'dev',
    bucket : 'beta-logico',
    region : 'us-east-1'
  },

  {
    environment: 'beta',
    bucket : 'beta-logico',
    region : 'us-east-1'
  },
  {
    environment: 'prod',
    bucket : 'prod-logico',
    region : 'us-east-1',
  }
];

export const FLEXICO_S3_CONFIG: s3Config[] =  [
  {
    environment: 'alpha',
    bucket : 'alpha-flexico',
    region : 'us-east-1'
  },
  {
    environment: 'dev',
    bucket : 'beta-flexico',
    region : 'us-east-1'
  },

  {
    environment: 'beta',
    bucket : 'beta-flexico',
    region : 'us-east-1'
  },
  {
    environment: 'prod',
    bucket : 'prod-flexico',
    region : 'us-east-1',
  }
];
export const TANC_S3_CONFIG: s3Config[] =  [
  {
    environment: 'alpha',
    bucket : 'alpha-tanc',
    region : 'us-east-1'
  },
  {
    environment: 'dev',
    bucket : 'beta-tanc',
    region : 'us-east-1'
  },

  {
    environment: 'beta',
    bucket : 'beta-tanc',
    region : 'us-east-1'
  },
  {
    environment: 'prod',
    bucket : 'prod-tanc',
    region : 'us-east-1',
  }
];

export const FS_S3_CONFIG: s3Config[] =  [
  {
    environment: 'alpha',
    bucket : 'abc-generic-bucket-alpha',
    secondaryBucket : 'abc-generic-bucket-alpha',
    region : 'us-east-1'
  },
  {
    environment: 'dev',
    bucket : 'ateam-analytics-responses-beta',
    secondaryBucket : 'accounting-central-analytics-data-beta',
    region : 'us-east-1'
  },

  {
    environment: 'beta',
    bucket : 'ateam-analytics-responses-beta',
    secondaryBucket : 'accounting-central-analytics-data-beta',
    region : 'us-east-1'
  },
  {
    environment: 'prod',
    bucket : 'ateam-analytics-responses-prod',
    secondaryBucket : 'accounting-central-analytics-data-prod',
    region : 'us-east-1',
  }
];

export const APIGATEWAY_CONFIG: APIGateWayConfig[] =  [
  {
    environment: 'alpha',
    ApiGateWayEndpoint : '',
  },
  {
    environment: 'dev',
    ApiGateWayEndpoint : 'https://lsyvtqofqf.execute-api.us-east-1.amazonaws.com/Beta',
  },

  {
    environment: 'beta',
    ApiGateWayEndpoint : 'https://lsyvtqofqf.execute-api.us-east-1.amazonaws.com/Beta',
  },
  {
    environment: 'prod',
    ApiGateWayEndpoint : 'https://djvqx97du0.execute-api.us-east-1.amazonaws.com/ProdRed',
  }
];

export const QUICKSIGHT_DASHBOARD_CONFIG:QuickSightDashboardConfig[] = [
  {
    environment: 'alpha',
    url : '',
  },
  {
    environment: 'dev',
    url : 'https://jfx11eme7b.execute-api.us-east-1.amazonaws.com/beta/get_embed_url',
  },

  {
    environment: 'beta',
    url : 'https://jfx11eme7b.execute-api.us-east-1.amazonaws.com/beta/get_embed_url',
  },
  {
    environment: 'prod',
    url : '',
  }
]

export const STEP_FUNCTION_CONFIG:StepFunctionConfig[] = [
  {
    environment: 'alpha',
    arn : 'arn:aws:states:us-east-1:657018391063:stateMachine:FRISCOTransactions',
  },
  {
    environment: 'dev',
    arn : 'arn:aws:states:us-east-1:330801203043:stateMachine:FRISCOTransactions',
  },

  {
    environment: 'beta',
    arn : 'arn:aws:states:us-east-1:330801203043:stateMachine:FRISCOTransactions',
  },
  {
    environment: 'prod',
    arn : 'arn:aws:states:us-east-1:359182851103:stateMachine:FRISCOTransactions',
  }
]

export const FLEXICO_STEP_FUNCTION_CONFIG:StepFunctionConfig[] = [
  {
    environment: 'alpha',
    arn : 'arn:aws:states:us-east-1:657018391063:stateMachine:FlexicoTransactions',
  },
  {
    environment: 'dev',
    arn : 'arn:aws:states:us-east-1:330801203043:stateMachine:FlexicoTransactions',
  },

  {
    environment: 'beta',
    arn : 'arn:aws:states:us-east-1:330801203043:stateMachine:FlexicoTransactions',
  },
  {
    environment: 'prod',
    arn : 'arn:aws:states:us-east-1:359182851103:stateMachine:FlexicoTransactions',
  }
]

export const GLUE_JOB_CONFIG:GlueJobConfig[] = [
  {
    environment: 'alpha',
    name : 'frisco_glue_main',
  },
  {
    environment: 'dev',
    name : 'frisco_glue_main',
  },

  {
    environment: 'beta',
    name : 'frisco_glue_main',
  },
  {
    environment: 'prod',
    name : 'frisco_glue_main',
  }
]

export const FLEXICO_GLUE_JOB_CONFIG:GlueJobConfig[] = [
  {
    environment: 'alpha',
    name : 'logging_poc',
  },
  {
    environment: 'dev',
    name : 'logging_poc',
  },

  {
    environment: 'beta',
    name : 'logging_poc',
  },
  {
    environment: 'prod',
    name : 'logging_poc',
  }
]

export const APP_FAV_ABC = 'favoritesABC'

export const FEATURED_ABC_APP = 'featuredABCApp'

export const CTI_LINK = "https://t.corp.amazon.com/create/templates/9c41d7b9-b693-433e-950a-ec29fcfce9f5"

export const FIRST_PASS_PRO_PERM_LDAP= "https://permissions.amazon.com/a/team/Accounting-ww"

// AWS RUM default casing convention.
// convention: element_action_name
export enum eRUM_CUSTOM_EVENT {
  USER_LOGGED_IN = 'user_logged_in'
}

export enum PORTAL {
  boffin, ted, mjemonitoring
}

export const mapper = {
  boffin : {
    id : '93',
    groups: ['ateam-bi','boffin-authorized-users']
  },
  ted : {
    id : '01H6SVT5HTFK3FXKA3MFXCXK12',
    groups: ['ateam-bi']
  },
  mjemonitoring : {
    id : '55',
    groups: ['ateam-bi', 'UI4BI_MJE_MONITORING_TEAM']
  },
  default : {
    id : '',
    groups: ['ateam-bi']
  }
}

export const quicksightAccountMapper = {
  'FAST': ['330801203043', '234247224352', '359182851103' ],
  'FGBSBI': ['fgbsbi-gamma', 'fgbsbi', '597646755921'],
  'AMAZONBI': ['amazonbi']
}

export enum APP_ACCESS_LEVEL {
  APP_ADMIN, FULL_EDIT, PARTIAL_EDIT, READ_ONLY, NO_ACCESS
}

export enum ACCESS_LEVEL_IDs {
  PORTAL_ADMIN = 1,
  APP_ADMIN = 2,
  FULL_EDIT = 3, 
  READ_ONLY = 5,
  APP_SPECIFIC_ACTION = 6,
  APP_GENERAL_ACCESS = 7
}
export const CORP_REPORTING_ADMIN_ACCESS_LEVELS = [ACCESS_LEVEL_IDs.APP_ADMIN]
export const ADMIN_ACCESS_LEVELS = [ACCESS_LEVEL_IDs.PORTAL_ADMIN]
export const ADD_APP_ACCESS_LEVELS = [ACCESS_LEVEL_IDs.PORTAL_ADMIN, ACCESS_LEVEL_IDs.APP_ADMIN]
export const DELETE_APP_ACCESS_LEVELS = [ACCESS_LEVEL_IDs.PORTAL_ADMIN, ACCESS_LEVEL_IDs.APP_ADMIN]
export const DOWNLOAD_APP_ACCESS_LEVELS = [ACCESS_LEVEL_IDs.PORTAL_ADMIN, ACCESS_LEVEL_IDs.APP_ADMIN]
// export const DELETE_APP_ACCESS_LEVELS = []
export const EDIT_APP_ACCESS_LEVELS = [ACCESS_LEVEL_IDs.PORTAL_ADMIN, ACCESS_LEVEL_IDs.APP_ADMIN, ACCESS_LEVEL_IDs.FULL_EDIT]

export const BANNER_PREFERENCE_TYPE = "BANNER"
export const GROUP_BANNER_PREFERENCE_TYPE = "GROUP_BANNER"
export const GROUP_BANNER_ASSOCIATION_ID = "GROUP_BANNER"
export const GROUP_BANNER_ASSOCIATION_ID_TYPE = "GROUP_BANNER"
export const BANNER_DISPLAY_EVERYWHERE_ID = "0"

export const PULSE_SURVEY_NOTIFICATION_PREFERENCE_TYPE = "PULSE_SURVEY"
export const GROUP_PULSE_SURVEY_NOTIFICATION_PREFERENCE_TYPE = "GROUP_PULSE_SURVEY"
export const GROUP_PULSE_SURVEY_ASSOCIATION_ID = "GROUP_PULSE_SURVEY"
export const GROUP_PULSE_SURVEY_ASSOCIATION_ID_TYPE = "GROUP_PULSE_SURVEY"
export enum BANNER_ASSOCIATION_ID_TYPES {
  ABC = "ABC",
  APP = "APP",
  CLOSE_PORTAL = "CLOSE_PORTAL",
  URL_PREFIX = "URL_PREFIX",
  FRISCO = "FRISCO",
  FLEXICO = "FLEXICO",
  LOGICO = "LOGICO",
}
export const ALTERNATIVE_APP_URLS = [
  "/MJEMonitoringHome",
  "/TEDHome",
  "/CorpReportingHome",
  "/BoffinHome",
]
